
import { useState } from 'react';
import { Tables } from "@/integrations/supabase/types";

type Quote = Tables<'quotes'>;

interface QuoteFormModalState {
  isOpen: boolean;
  mode: 'new' | 'revise' | 'variation';
  parentQuote?: Quote;
}

export const useQuoteFormModal = () => {
  const [quoteFormModal, setQuoteFormModal] = useState<QuoteFormModalState>({
    isOpen: false,
    mode: 'new'
  });

  const handleReviseQuote = (quote: Quote) => {
    setQuoteFormModal({
      isOpen: true,
      mode: 'revise',
      parentQuote: quote
    });
  };

  const handleAddVariation = (quote: Quote) => {
    setQuoteFormModal({
      isOpen: true,
      mode: 'variation',
      parentQuote: quote
    });
  };

  const handleCloseModal = () => {
    setQuoteFormModal({ isOpen: false, mode: 'new' });
  };

  return {
    quoteFormModal,
    handleReviseQuote,
    handleAddVariation,
    handleCloseModal
  };
};
